import React, { FC } from 'react'
import { Text, Flex, IText } from '@ads/front-ds'
import { TTranslationsKeys, lng } from '@ads/front-core/locales'

export interface ICampaignSectionHeader {
  headerLngKey: TTranslationsKeys
  headerLngArgs?: Record<string, unknown>
  descriptionLngKey?: TTranslationsKeys
  descriptionLngArgs?: Record<string, unknown>
  descriptionFontSize?: IText['fontSize']
}

export const CampaignSectionHeader: FC<ICampaignSectionHeader> = ({
  headerLngKey,
  headerLngArgs,
  descriptionLngKey,
  descriptionLngArgs,
  descriptionFontSize,
}) => (
  <Flex flexDirection="column" gap="xxs">
    <Text fontSize="l">{lng(headerLngKey, headerLngArgs)}</Text>
    {descriptionLngKey && (
      <Text
        fontSize={descriptionFontSize || 'm'}
        color="grey50"
        styleCss={{ whiteSpace: 'break-spaces' }}
      >
        {lng(descriptionLngKey, descriptionLngArgs)}
      </Text>
    )}
  </Flex>
)
